var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-code-panel"},[_c('div',{ref:"qrCodeUrl",staticClass:"qr-code"})])}
var staticRenderFns = []

export { render, staticRenderFns }